import { render, staticRenderFns } from "./ProvinceSelect.vue?vue&type=template&id=678dd5c1&scoped=true"
import script from "./ProvinceSelect.vue?vue&type=script&lang=js"
export * from "./ProvinceSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678dd5c1",
  null
  
)

export default component.exports